<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="component-header-title">
      <h2>Edit OPB Company</h2>
      @if (companyData) {
        <p class="component-header-subtitle">{{ companyData.name }}</p>
      }
    </div>
  </div>
  @if (companyData) {
    <app-opb-company-form [isEditMode]="true" [companyData]="companyData" />
  }
</div>
